import { useTheme } from '../hooks/useTheme';
import { LoginForm } from '../components/auth/LoginForm';
import { useEffect, useState } from 'react';
import logoCompleto from '../assets/Logo.png';

export const LoginPage = () => {
  const { theme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleLogin = (data: { email: string; password: string }) => {
  };

  return (
    <div className={`min-h-screen transition-colors duration-500 overflow-hidden ${
      theme === 'dark' 
        ? 'bg-gradient-to-br from-gray-900 via-slate-800 to-gray-900' 
        : 'bg-gradient-to-br from-[#4CAF50]/10 via-white to-[#2196F3]/10'
    }`}>
      
      {/* CSS para animaciones personalizadas */}
      <style>{`
        @keyframes floatUp {
          0% { transform: translateY(0) rotate(0deg); opacity: 0; }
          10% { opacity: 1; }
          90% { opacity: 1; }
          100% { transform: translateY(-100vh) rotate(360deg); opacity: 0; }
        }
        @keyframes floatRotate {
          0% { transform: translate(0, 0) rotate(0deg); }
          25% { transform: translate(20px, -30px) rotate(90deg); }
          50% { transform: translate(0, -60px) rotate(180deg); }
          75% { transform: translate(-20px, -30px) rotate(270deg); }
          100% { transform: translate(0, 0) rotate(360deg); }
        }
        @keyframes heartbeat {
          0%, 100% { transform: scale(1); }
          14% { transform: scale(1.1); }
          28% { transform: scale(1); }
          42% { transform: scale(1.1); }
          70% { transform: scale(1); }
        }
        @keyframes waveMove {
          0%, 100% { transform: translateX(0); }
          50% { transform: translateX(10px); }
        }
        @keyframes waveSway {
          0%, 100% { transform: translateX(0) scaleX(1); }
          50% { transform: translateX(15px) scaleX(1.1); }
        }
        @keyframes lightMove {
          0%, 100% { transform: translateY(-100%); opacity: 0; }
          50% { transform: translateY(100vh); opacity: 1; }
        }
        @keyframes rotate360 {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes expandCircle {
          0% { transform: scale(0); opacity: 0.8; }
          100% { transform: scale(4); opacity: 0; }
        }
        @keyframes moveParticle {
          0% { opacity: 0; transform: scale(0); }
          10% { opacity: 1; transform: scale(1); }
          90% { opacity: 1; transform: scale(1); }
          100% { opacity: 0; transform: scale(0); }
        }
        @keyframes pulseWave {
          0% { transform: translate(-50%, -50%) scale(0.5); opacity: 1; }
          100% { transform: translate(-50%, -50%) scale(3); opacity: 0; }
        }
        @keyframes bounceIn {
          0% { transform: scale(0); opacity: 0; }
          50% { transform: scale(1.2); }
          100% { transform: scale(1); opacity: 1; }
        }
        @keyframes wiggle {
          0%, 100% { transform: rotate(-3deg); }
          50% { transform: rotate(3deg); }
        }
        @keyframes glow {
          0%, 100% { box-shadow: 0 0 20px rgba(255,255,255,0.3); }
          50% { box-shadow: 0 0 40px rgba(255,255,255,0.6), 0 0 60px rgba(255,255,255,0.4); }
        }
        @keyframes slideInBounce {
          0% { transform: translateX(-100px); opacity: 0; }
          60% { transform: translateX(20px); opacity: 1; }
          100% { transform: translateX(0); }
        }
        @keyframes morphBlob {
          0%, 100% { border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%; }
          50% { border-radius: 30% 60% 70% 40% / 50% 60% 30% 60%; }
        }
        .animate-bounce-in {
          animation: bounceIn 0.8s ease-out forwards;
        }
        .animate-wiggle {
          animation: wiggle 2s ease-in-out infinite;
        }
        .animate-glow {
          animation: glow 2s ease-in-out infinite;
        }
        .animate-morph {
          animation: morphBlob 8s ease-in-out infinite;
        }
      `}</style>
      
      {/* Contenido principal */}
      <div className="relative z-10 min-h-screen flex">
        {/* Left Section - Solo el logo grande */}
        <div className={`hidden lg:flex lg:w-[60%] relative overflow-hidden ${
          theme === 'dark' ? 'bg-gray-50' : 'bg-white'
        }`}>
          
          {/* Rayos de luz de fondo */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
            {/* Rayo diagonal 1 - más ancho y visible */}
            <div 
              className="absolute w-[3px] h-[200%] animate-lightBeam"
              style={{ 
                left: '15%', 
                top: '-50%',
                transform: 'rotate(20deg)',
                animationDelay: '0s',
                background: 'linear-gradient(to bottom, transparent 0%, rgba(76,175,80,0.6) 20%, rgba(33,150,243,0.8) 50%, rgba(76,175,80,0.6) 80%, transparent 100%)',
                boxShadow: '0 0 20px 5px rgba(255,255,255,0.5)',
              }}
            />
            {/* Rayo diagonal 2 */}
            <div 
              className="absolute w-[4px] h-[200%] animate-lightBeam"
              style={{ 
                left: '35%', 
                top: '-50%',
                transform: 'rotate(20deg)',
                animationDelay: '1.5s',
                background: 'linear-gradient(to bottom, transparent 0%, rgba(33,150,243,0.5) 20%, rgba(76,175,80,0.7) 50%, rgba(33,150,243,0.5) 80%, transparent 100%)',
                boxShadow: '0 0 15px 3px rgba(255,255,255,0.4)',
              }}
            />
            {/* Rayo diagonal 3 */}
            <div 
              className="absolute w-[3px] h-[200%] animate-lightBeam"
              style={{ 
                left: '55%', 
                top: '-50%',
                transform: 'rotate(20deg)',
                animationDelay: '3s',
                background: 'linear-gradient(to bottom, transparent 0%, rgba(76,175,80,0.6) 20%, rgba(33,150,243,0.8) 50%, rgba(76,175,80,0.6) 80%, transparent 100%)',
                boxShadow: '0 0 20px 5px rgba(255,255,255,0.5)',
              }}
            />
            {/* Rayo diagonal 4 */}
            <div 
              className="absolute w-[2px] h-[200%] animate-lightBeam"
              style={{ 
                left: '75%', 
                top: '-50%',
                transform: 'rotate(20deg)',
                animationDelay: '4.5s',
                background: 'linear-gradient(to bottom, transparent 0%, rgba(33,150,243,0.4) 20%, rgba(76,175,80,0.6) 50%, rgba(33,150,243,0.4) 80%, transparent 100%)',
                boxShadow: '0 0 10px 2px rgba(255,255,255,0.3)',
              }}
            />
            {/* Rayo adicional más brillante */}
            <div 
              className="absolute w-[2px] h-[200%] animate-lightBeam"
              style={{ 
                left: '45%', 
                top: '-50%',
                transform: 'rotate(20deg)',
                animationDelay: '2.2s',
                background: 'linear-gradient(to bottom, transparent 0%, rgba(255,255,255,0.8) 30%, rgba(255,255,255,0.9) 50%, rgba(255,255,255,0.8) 70%, transparent 100%)',
                boxShadow: '0 0 30px 10px rgba(255,255,255,0.6)',
              }}
            />
            {/* Brillo central más intenso */}
            <div 
              className="absolute w-[500px] h-[500px] rounded-full animate-pulseGlow z-0"
              style={{
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                background: 'radial-gradient(circle, rgba(76,175,80,0.3) 0%, rgba(33,150,243,0.2) 30%, rgba(255,255,255,0.1) 50%, transparent 70%)',
              }}
            />
          </div>
          
          {/* Logo de ConfiFarma centrado */}
          <div className="absolute inset-0 flex items-center justify-center z-20">
            <div 
              className={`relative transition-all duration-1000 ${mounted ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`}
              style={{ 
                animationDelay: '0.3s',
                animation: mounted ? 'gentleFloat 6s ease-in-out infinite' : 'none',
              }}
            >
              <img 
                src={logoCompleto} 
                alt="ConfiFarma Amiga" 
                className="h-[55vh] w-auto drop-shadow-2xl"
              />
              
              {/* Destellos de luz alrededor del logo */}
              <div className="absolute inset-0 pointer-events-none">
                {/* Destello superior izquierdo */}
                <div 
                  className="absolute -top-8 -left-8 w-6 h-6 bg-white rounded-full animate-twinkle"
                  style={{ animationDelay: '0s' }}
                />
                {/* Destello superior derecho */}
                <div 
                  className="absolute -top-4 -right-4 w-4 h-4 bg-white rounded-full animate-twinkle"
                  style={{ animationDelay: '0.7s' }}
                />
                {/* Destello inferior izquierdo */}
                <div 
                  className="absolute -bottom-6 -left-4 w-3 h-3 bg-white rounded-full animate-twinkle"
                  style={{ animationDelay: '1.2s' }}
                />
                {/* Destello inferior derecho */}
                <div 
                  className="absolute -bottom-4 right-1/4 w-5 h-5 bg-white rounded-full animate-twinkle"
                  style={{ animationDelay: '0.5s' }}
                />
                {/* Destello superior centro */}
                <div 
                  className="absolute -top-6 left-1/2 w-2 h-2 bg-white rounded-full animate-twinkle"
                  style={{ animationDelay: '1.8s' }}
                />
              </div>
            </div>
          </div>

          {/* CSS para animaciones */}
          <style>{`
            @keyframes gentleFloat {
              0%, 100% { transform: translateY(0) scale(1); }
              50% { transform: translateY(-10px) scale(1.01); }
            }
            @keyframes twinkle {
              0%, 100% { 
                opacity: 0; 
                transform: scale(0.5);
                box-shadow: 0 0 0 0 rgba(255,255,255,0);
              }
              50% { 
                opacity: 1; 
                transform: scale(1);
                box-shadow: 0 0 20px 10px rgba(255,255,255,0.8);
              }
            }
            .animate-twinkle {
              animation: twinkle 2s ease-in-out infinite;
            }
            @keyframes lightBeam {
              0% { 
                transform: rotate(20deg) translateY(-100%);
                opacity: 0;
              }
              15% {
                opacity: 1;
              }
              85% {
                opacity: 1;
              }
              100% { 
                transform: rotate(20deg) translateY(100%);
                opacity: 0;
              }
            }
            .animate-lightBeam {
              animation: lightBeam 8s ease-in-out infinite;
            }
            @keyframes pulseGlow {
              0%, 100% {
                opacity: 0.3;
                transform: translate(-50%, -50%) scale(0.8);
              }
              50% {
                opacity: 0.6;
                transform: translate(-50%, -50%) scale(1.2);
              }
            }
            .animate-pulseGlow {
              animation: pulseGlow 4s ease-in-out infinite;
            }
          `}</style>
        </div>

        {/* Divisor elegante entre secciones */}
        <div className="hidden lg:block absolute left-[60%] top-0 bottom-0 w-32 -ml-16 z-20 pointer-events-none">
          {/* Degradado suave de transición */}
          <div 
            className="absolute inset-0"
            style={{
              background: theme === 'dark' 
                ? 'linear-gradient(90deg, transparent, rgba(255,255,255,0.05) 50%, transparent)' 
                : 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3) 50%, transparent)',
            }}
          />
          
          {/* Línea vertical con brillo */}
          <div className="absolute left-1/2 top-10 bottom-10 w-px bg-gradient-to-b from-transparent via-white/40 to-transparent" />
          
          {/* Círculos decorativos flotantes */}
          <div className="absolute top-1/4 left-1/2 -translate-x-1/2">
            <div className="w-3 h-3 rounded-full bg-white/40 animate-pulse" style={{ animationDuration: '2s' }} />
          </div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2">
            <div className="w-2 h-2 rounded-full bg-white/30 animate-pulse" style={{ animationDuration: '3s', animationDelay: '0.5s' }} />
          </div>
          <div className="absolute top-3/4 left-1/2 -translate-x-1/2">
            <div className="w-3 h-3 rounded-full bg-white/40 animate-pulse" style={{ animationDuration: '2.5s', animationDelay: '1s' }} />
          </div>
        </div>

        {/* Right Section - Login Form */}
        <div 
          className={`w-full lg:w-[40%] flex items-center justify-center p-8 transition-all duration-700 delay-500 relative z-10 ${
            mounted ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-20'
          }`}
        >
          <LoginForm onSubmit={handleLogin} />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
